import { render, staticRenderFns } from "./OnboardingComponent.vue?vue&type=template&id=7ecaded5&scoped=true"
import script from "./OnboardingComponent.vue?vue&type=script&lang=ts"
export * from "./OnboardingComponent.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingComponent.vue?vue&type=style&index=0&id=7ecaded5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecaded5",
  null
  
)

export default component.exports